import { map, filter, find, reduce } from 'lodash';
import moment from 'moment';
import { getBalanceOverrideColor } from 'application/util/balance-highlight.util';

import './calendar-header.style.sass';
import template from './calendar-header.tpl.pug';

class CalendarHeaderController {
    $onChanges(changeObject) {
        if (changeObject.timestamp) {
            this.date = moment(changeObject.timestamp.currentValue).format('MMMM YYYY');
        }

        if (changeObject.team || changeObject.calendarIds) {
            this.calendars = this.getSelectedCalendarsByIds(this.team || {}, this.calendarIds || []);
            this.selectedName = this.getSelectedCalendarsName(this.calendars);
        }
    }

    getSelectedCalendarsByIds(team, calendarIds) {
        let calendars = team.calendars || [];

        return filter(
            map(
                calendarIds || [],
                (calendarId) => find(calendars, (calendar) => calendar.id === calendarId)
            )
        );
    }

    get balance() {
        return reduce(this.calendars || [], (total, calendar) => total + calendar.balance, 0);
    }

    getBalanceOverrideColor(value) {
        if (this.loading) {
            return null;
        }

        return getBalanceOverrideColor(value, this.balanceWarningThreshold);
    }

    getSelectedCalendarsName(calendars) {
        if (!calendars || calendars.length === 0) {
            return null;
        }

        if (calendars.length === 1) {
            return calendars[0].name;
        }

        return `${calendars.length} calendars selected`;
    }

    openTeamManagement() {
        this.blur();

        return this.onTeamManagementClick();
    }

    selectPreviousMonth() {
        return this.onPreviousMonthClick();
    }

    selectNextMonth() {
        return this.onNextMonthClick();
    }

    selectToday() {
        this.blur();

        return this.onTodayClick();
    }

    selectMonth(timestamp) {
        return this.onMonthClick({
            timestamp
        });
    }

    hover() {
        this.areMonthsVisible = true;
    }

    blur() {
        this.areMonthsVisible = false;
    }

    searchTermChanged(terms) {
        this.terms = terms;

        return this.onSearchTermsChanged({
            terms
        });
    }

    toggleSearchVisibility(focused) {
        if (focused || !this.terms || this.terms.length === 0) {
            this.searchVisible = focused;
        }
    }
}

export default {
    selector: 'dbACalendarHeader',
    template: template(),
    controller: CalendarHeaderController,
    bindings: {
        loading: '<',
        team: '<',
        calendarIds: '<',
        timestamp: '<',
        months: '<',
        canCaptureSearch: '<',
        balanceWarningThreshold: '<',
        onTeamManagementClick: '&',
        onPreviousMonthClick: '&',
        onNextMonthClick: '&',
        onTodayClick: '&',
        onMonthClick: '&',
        onSearchTermsChanged: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-header/calendar-header.cmpt.js